<template>
	<div class="cotent_app">
		<div class="content_top">
			<img :src="category.dingimg" alt="" class="w100">
			<!-- <h3>{{category.cat_name}}</h3> -->
		</div>
		<div class="content_center">
			<div class="container">
				<div class="text_box">
					<h3>{{category.cat_name}}</h3>
					<p>
						{{category.description}}
					</p>
				</div>
				<div class="swiper-container">
				    <div class="swiper-wrapper">
				        <div class="swiper-slide" v-for="(item,index) in piclist" :key="index">
				           <img class="w100" :src="item.show_img" alt="" @click="imgYu(item.show_img)">
							
				        </div>
						
				    </div>
				    <div class="swiper-pagination" slot="pagination">
						
					</div>
				</div>
			</div>
		</div>
		<div class="yzbox" @click="hideYu()">
			<img src="" alt="" id='yz'>
		</div>
	</div>
</template>

<script>
	import axios from 'axios';
	
	import Swiper from 'swiper';
	export default {
		data() {
			return {
				category:'',
				cid:0,
                banner:"",
				piclist:[],
			}
		},
		methods:{
			
			imgYu(src){
				$(".yzbox img").attr("src",src)
				$(".yzbox").show();
				
			},
			hideYu(src){
				$(".yzbox").hide();
				
				$(".yzbox img").attr("src",'')
				
			},
		},
        watch: {
            '$route.query.cid'(newValue) {
              this.cid = newValue; // 将新的参数值保存到组件的monitoredParam属性中
              // 执行其他操作或调用其他方法
               this.$nextTick(() => {
                  // this.$forceUpdate()
                  window.location.reload()
              })
            },
        },
		mounted(){
			var that = this;
            that.banner=require('@/assets/images/appliction/banner'+that.$route.query.cid+'.jpg')
			axios({
				method: 'post',
				url:`${this.$apiYf}/artilecategoryapi.php`,
				data: {
					cid:that.$route.query.cid
				},
				headers: {'Content-Type': 'multipart/form-data'},
			}).then((res) =>{
				that.category=res.data.category;
				that.piclist=res.data.piclist;
			    that.$nextTick(() => {
			    	that.lbSwiper = new Swiper ('.swiper-container', {
			    		loop: true, 
			    		autoplay:true,
			    		pagination: {
			    			el: '.swiper-pagination',
			    			clickable: true,
			    		},
			    		autoHeight:true,
			    		centeredSlides: true,
			    		slidesPerView: "auto",
			    		speed: 500,
			    		roundLengths : true, 
			    		observer:true,
			    		observeParents:true,
			    		observeSlideChildren:true,
			    		calculateHeight: true,
			    		
			    	});
			    })
			})
			
		}
	}
</script>

<style lang="scss">
    .cotent_app{
        .content_center{
        	.container{display: flex;margin: 5vw auto 3vw;align-items: flex-start;
        		.text_box{width: 40%;margin-right: 5%;
        			h3{font-size: 48px;color: #ad1f24;margin-bottom: 44px;
        				position: relative;line-height: 1.8;
        				
        				&::after{
        					content: '';
        					border-bottom: solid 4px #ad1f24;width: 120px;position: absolute;bottom: 0;left:0;
        				}
        			}
        			p{font-size: 16px;line-height: 2;}
        		}
        	}
        	.swiper-container {
        	    flex:1; overflow: hidden; position: relative;
        	    .swiper-wrapper {
        	        width: 100%; 
        	        .swiper-slide {
        	            width: 80%;overflow: hidden;margin: 0 1%;
        				img{opacity: 0.9;}
        				&:hover{
        					img{opacity: 1;}
        				}
        				
        	        }
        	    }
        		
        		
        	    .swiper-pagination {
        	        text-align: center;position: relative;bottom: 0;margin-top: 10px;
        	        span.swiper-pagination-bullet {
        	            width: 20px; height: 5px;border-radius:0;  opacity: 1;background:#aaa;display: inline-block;
        	            &.swiper-pagination-bullet-active {
        	                background:#333; 
        	            }
        	        }
        	    }
        	    
        		
        		
        	}
        }
        .yzbox{width:100%;height:100vh;position: fixed;left:0;top:0;z-index:999;
        background:rgba(0,0,0,0.7);display: none;
        	img{width:80%;position: absolute;left:0;top:0;bottom:0;right:0;display: block;margin:auto;}
        }
    }
	
</style>